/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React, { useState, useEffect } from "react"
import { useLockData } from "../hooks/locks"
import { useTheme } from "@cd2/theme"
import { P } from "@cd2/text"
import { Icon } from "@cd2/components"

export function LockBanner({
  id,
  type,
  onUnlock,
  onLockChange,
}: {
  id: string
  type: string
  onUnlock: () => void | Promise<void>
  onLockChange?: (locked: boolean) => void
}) {
  const { themeColor } = useTheme()

  const lockData = useLockData(type)
  const lock = lockData && lockData.find(x => x.resourceId === id)

  const [locked, setLocked] = useState(!!lock)

  useEffect(() => {
    const fn = async () => {
      const currentLocked = !!lock

      if (currentLocked !== locked) {
        setLocked(currentLocked)

        // if we were locked then call onUnlock
        if (locked) {
          await onUnlock()
        }

        if (onLockChange) {
          onLockChange(currentLocked)
        }
      }
    }
    fn()
  }, [JSON.stringify(lock)])

  if (!locked || !lock) {
    return null
  }

  return (
    <React.Fragment>
      <div
        css={css`
          background-color: ${themeColor("secondary")};
          position: relative;
          z-index: 6;
        `}
      >
        <div
          css={css`
            padding: 8px 32px;
            max-width: 1200px;
            margin: 0 auto;
          `}
        >
          <P color="white">
            <Icon
              css={css`
                margin-right: 6px;
              `}
              color="white"
              icon="lock"
            />
            Record is currently locked by <b>{lock.userName}</b> and cannot be edited
          </P>
        </div>
      </div>
      <div
        css={css`
          position: absolute;
          background-color: white;
          opacity: 0.6;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 5;
          pointer-events: none;
        `}
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
        }}
      />
    </React.Fragment>
  )
}
